<!-- dangerously set the inner html with the content string -->

<div class="references-alert white-bg">

  <!-- for each component page in the content, render it -->
  @for (component of components; track component) {
    <div class="page">
      <p><em><strong>{{component.properties.videoName}}</strong> (Vimeo ID: {{component.properties.vimeoId}})</em></p>
      @for (element of component.elements; track element) {
        <div>
          @if (element.type == 'header') {
            <h2 [innerHTML]="element.value"></h2>
          }
          @if (element.type == 'link') {
            <a target="_blank" [href]="element.value">{{element.value}}</a>
          }
          @if (element.type == 'p') {
            <p [innerHTML]="element.value"></p>
          }
        </div>
      }
    </div>
  }
</div>
